import React, {useState, useEffect} from "react";
import {Button, Input, Select, Form} from "tea-component";
import { useDblIntl } from "@/pages/datalab/utils/utils";

export default function CustomSelect(props: any) {
  const { options=[], onOpen, boxClassName='', tips='', customConfirm, defaultValue, value, onChange, ...resetProps } = props;
  const { commonFormatMessage, isEn } = useDblIntl("data_table");
  const [showCustomLabelInput, setShowCustomLabelInput] = useState<boolean>(false);
  const [customLabelInputValue, setCustomLabelInputValue] = useState<string>('');
  const [selected, setSelected] = useState(value || defaultValue);
  const [validMessage, setValidMessage] = useState('');
  useEffect(() => {
    (customLabelInputValue && (selected !== customLabelInputValue)) && setSelected(customLabelInputValue);
  }, [JSON.stringify(options)]);
  return (<Select
    appearance="button"
    // placeholder={commonFormatMessage('select_placeholder')}
    matchButtonWidth
    value={selected}
    onChange={(value) => {
      setSelected(value);
      onChange?.(value);
    }}
    {...resetProps}
    options={!showCustomLabelInput ? options : []}
    boxClassName={`${showCustomLabelInput ? 'confirm-model-customize' : ''} ${boxClassName}`}
    onOpen={() => {
      setShowCustomLabelInput(false);
      onOpen?.();
    }}
    tips={showCustomLabelInput ? '' : tips}
    footer={
      !showCustomLabelInput ? (
        <div
          style={{ color: '#0076ff', textAlign: 'left', cursor: 'pointer' }}
          onClick={() => {
            setShowCustomLabelInput(true);
          }}
        >
          {commonFormatMessage("customize")}
        </div>
      ) : (
        <>
          <Form.Item status={!!validMessage ? 'error' : undefined} message={validMessage} showStatusIcon={false} style={{display: 'block'}}>
            <Input
              size="full"
              placeholder={commonFormatMessage("customize_placeholder")}
              onChange={(value) => {
                setCustomLabelInputValue(value);
              }}
              autoFocus
            />
          </Form.Item>
          <div className="confirm-flex-end" style={{ marginTop: '10px' }}>
            <Button
              style={{ minWidth: 50, padding: '0px 15px' }}
              type="primary"
              disabled={!customLabelInputValue.trim()}
              onClick={() => {
                if (options.some(opt => customLabelInputValue === opt.value)) {
                  setValidMessage(isEn ? 'Option duplication' : '选项重复');
                  return;
                }
                customConfirm?.(customLabelInputValue);
                onChange?.(customLabelInputValue);
                validMessage && setValidMessage('');
                setShowCustomLabelInput(false);
              }}
            >
              {commonFormatMessage("confirm")}
            </Button>
            <Button
              style={{ minWidth: 50, padding: '0px 15px' }}
              type="weak"
              onClick={() => {
                validMessage && setValidMessage('');
                setShowCustomLabelInput(false);
              }}
            >
              {commonFormatMessage("return")}
            </Button>
          </div>
        </>
      )}
  />);
}